import * as React from 'react';
import type {CSSProperties} from '@packages/utilities/css-properties-type';
import {styled} from '@packages/utilities/styled';
import {type GridProps} from './Grid.types';
import {space} from '../utils/space';

function filterUndefinedStyleValues(styles: CSSProperties) {
  Object.keys(styles).forEach(
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ObjMap<StrictCSSProperties, ToMaybeType>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ObjMap<StrictCSSProperties, ToMaybeType>'.
    // eslint-disable-next-line webflow/no-delete
    (key) => styles[key] === undefined && delete styles[key]
  );
  return styles;
}

const View = styled('div')(({
  alignItems,
  gridAutoColumns,
  gridAutoFlow,
  gridAutoRows,
  gridColumn,
  gridColumnGap = 2,
  gridGap,
  gridRow,
  gridRowGap = 1,
  gridTemplate,
  gridTemplateAreas,
  gridTemplateColumns,
  gridTemplateRows,
  justifyContent,
  padding,
  style,
}) => {
  const hasGridGap = gridGap !== undefined;

  const styles: CSSProperties = {
    alignItems,
    boxSizing: 'border-box',
    display: 'grid',
    gap: space(gridGap),
    gridAutoColumns,
    gridAutoFlow,
    gridAutoRows,
    gridColumn,
    gridColumnGap: hasGridGap ? undefined : space(gridColumnGap),
    gridRow,
    gridRowGap: hasGridGap ? undefined : space(gridRowGap),
    gridTemplate,
    gridTemplateAreas,
    gridTemplateColumns,
    gridTemplateRows,
    justifyContent,
    padding,
    ...style,
  };

  return filterUndefinedStyleValues(styles);
});

/**
 * @deprecated use `View` from `@packages/systems/spring` instead
 */
export const Grid = React.forwardRef<any, GridProps>((props, ref) => {
  return <View data-legacy-ds="Grid" {...props} ref={ref} />;
});

export default Grid;
